import useMutationApi from 'src/api/useMutationApi';

interface CreateProductVariantData {
  productId: string;
  attributes: Record<string, unknown>;
  upc?: string | null;
  sku?: string | null;
  active?: boolean;
  originId?: string | null;
  originSystem?: string | null;
  originEntity?: string | null;
  originMetadata?: Record<string, unknown> | null;
  originAttributes?: Record<string, unknown> | null;
}

interface CreateProductVariantResponse {
  productVariant: {
    id: string;
    productId: string;
    attributes: Record<string, unknown>;
    upc?: string | null;
    sku?: string | null;
    active?: boolean;
    originId?: string | null;
    originSystem?: string | null;
    originEntity?: string | null;
    originMetadata?: Record<string, unknown> | null;
    originAttributes?: Record<string, unknown> | null;
    createdAt: string;
    updatedAt: string;
  };
}

const useCreateProductVariant = (
  onSuccess?: (response: CreateProductVariantResponse) => void,
) => {
  return useMutationApi<CreateProductVariantData, CreateProductVariantResponse>(
    {
      endpoint: 'inventory-management/products-v2/product-variants',
      method: 'POST',
      options: {
        onSuccess: (response) => {
          onSuccess?.(response.data);
        },
      },
      successMessage: 'Product variant created successfully',
    },
  );
};

export default useCreateProductVariant;
